import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { Element, Text } from 'domhandler';
import { parseDocument } from 'htmlparser2';
import { useShellTranslation } from '@/hooks/useShellTranslation/useShellTranslation';
import { Link } from '../Link';
export const CustomTrans = ({ i18nKey, linksUrl = {}, values }) => {
    const { t } = useShellTranslation();
    const translation = t(i18nKey, { replace: values });
    const renderWithComponents = (htmlString) => {
        const document = parseDocument(htmlString);
        const parseNode = (node, index) => {
            // If it's a text node, return the raw text
            if (node instanceof Text) {
                return _jsx("span", { children: node.data }, `span-${index}`);
            }
            // If it's an element node (Element)
            if (node instanceof Element) {
                const tagName = node.tagName.toLowerCase();
                // Recursively retrieve the children
                const children = node.children.map((childNode, index) => parseNode(childNode, index));
                if (tagName === 'br') {
                    return _jsx("br", {}, `br-${index}`);
                }
                if (tagName === 'p') {
                    return (_jsx(Box, { as: "p", children: children }, `p-${index}`));
                }
                if (tagName === 'b') {
                    return (_jsx(Box, { as: "strong", children: children }, `b-${index}`));
                }
                if (tagName === 'i') {
                    return _jsx("i", { children: children }, `i-${index}`);
                }
                // If a custom component is provided for this tag
                if (linksUrl[tagName]) {
                    return (_jsx(Link, { href: linksUrl[tagName].href, isExternal: !!linksUrl[tagName].isExternal, mediumAttribute: linksUrl[tagName].mediumAttribute, children: children }, `link-${index}`));
                }
                // By default, return the children
                return children;
            }
            return null;
        };
        // Process all child nodes of the document body
        return document.children.map((node, index) => parseNode(node, index));
    };
    return _jsx(_Fragment, { children: renderWithComponents(translation) });
};
